import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
   name: 'endWithChar',
   standalone: true
})
export class EndWithCharPipe implements PipeTransform {

   transform(value: string | null | undefined, character = '.'): string | null {
      if (value == null) return null
      if (typeof value !== 'string') {
         throw new Error('value for endWithChar not a string')
      }
      if (value) {
         return value + character
      }
      else {
         return value
      }
   }

}
